import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/ad-placements',
    name: 'page-ad-placements',
    component: () => import('@/pages/AdPlacements'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/ad-placement/new',
    name: 'page-ad-placement-new',
    component: () => import('@/pages/AdPlacement'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/ad-placement/:id',
    name: 'page-ad-placement',
    component: () => import('@/pages/AdPlacement'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
